import * as React from 'react';
import { EPromoType } from '../../types/newBuldings/promo';
import { ActionIcon } from './PromoIcons/ActionIcon';
import { DiscountIcon } from './PromoIcons/DiscountIcon';
import { MortgageIcon } from './PromoIcons/MortgageIcon';
import * as styles from './DiscountCard.css';

export function getPromoIcon(type: EPromoType): React.ReactElement {
  switch (type) {
    case EPromoType.Discount:
      return <DiscountIcon />;
    case EPromoType.Mortgage:
      return <MortgageIcon />;
    case EPromoType.Bonus:
      return <ActionIcon />;
    default:
      return <DiscountIcon />;
  }
}

export function getPromoClassName(type: EPromoType) {
  switch (type) {
    case EPromoType.Discount:
      return styles['discount'];
    case EPromoType.Mortgage:
      return styles['mortgage'];
    case EPromoType.Bonus:
      return styles['bonus'];
    default:
      return styles['discount'];
  }
}
